/* eslint-disable */
export default function getQueryParams(qs) {
  if (typeof qs == "undefined") {
    qs = document.location.search;
  }
  qs = qs.split("+").join(" ");
  let params = {},
    tokens,
    re = /[?&]?([^=]+)=([^&]*)/g;
  while ((tokens = re.exec(qs))) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }
  return params;
}
